"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypePatch = void 0;
class EventTypePatch {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypePatch.attributeTypeMap;
    }
}
exports.EventTypePatch = EventTypePatch;
EventTypePatch.discriminator = undefined;
EventTypePatch.attributeTypeMap = [
    {
        "name": "archived",
        "baseName": "archived",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "featureFlag",
        "baseName": "featureFlag",
        "type": "string",
        "format": ""
    },
    {
        "name": "schemas",
        "baseName": "schemas",
        "type": "{ [key: string]: any; }",
        "format": ""
    }
];
//# sourceMappingURL=EventTypePatch.js.map